export default __webpack_public_path__ + "static/media/infoIllustration7.0d687b2d.gif";